import { AudienceFilter, defineMessage, defineTopic } from 'magpie-lib/models';
import * as t from 'ts-schema';
const hostNavigateMessage = defineMessage({
  type: '@@video-components-external/utility/host-navigate',
  payloadSchema: t.object({
    location: t.string,
    newTab: t.boolean
  })
});
export const UtilityMessages = {
  hostNavigateMessage
};
export const utilityTopicDef = defineTopic({
  name: '@@video-components-external/utility/utils',
  messages: [UtilityMessages.hostNavigateMessage],
  enableRuntimeValidation: false,
  audience: AudienceFilter.builder().build()
});